/**
`com-native-bridge`
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import 'wdpr-ra-javascript-native-bridge/dist/wdpr-ra-javascript-native-bridge.min.js';

/**
 * `com-native-bridge`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class COMNativeBridge extends PolymerElement {

  static get is() { return 'com-native-bridge'; }
  static get properties() {
    return {
      /**
       * @desc Flag to indicate whether current app is embedded to a native mobile app
       * @type {Boolean}
       */
      isEmbedded: {
        type: Boolean,
        reflectToAttribute: true,
        notify: true
      },

      /**
       * @desc Flag to indicate whether current app is embedded to a ios native mobile app
       * @type {Boolean}
       */
      isIOS: {
        type: Boolean,
        reflectToAttribute: true,
        notify: true
      },

      /**
       * @desc Flag to indicate whether current app is embedded to a android native mobile app
       * @type {Boolean}
       */
      isAndroid: {
        type: Boolean,
        reflectToAttribute: true,
        notify: true
      },

      /**
       * @desc Flag to indicate whether current app is embedded to a flutter mobile app
       * @type {Boolean}
       */
      isFlutter: {
        type: Boolean,
        reflectToAttribute: true,
        notify: true
      },

      /**
       * @desc native bridge object
       * @type {Object}
       */
      _nativeBridge: Object,

      /**
       * @desc native bridge plugin name to use
       * @type {String}
       */
      nativeBridgePluginName: {
        type: String,
        value: 'COMWebComponentsNBPlugin'
      },

      /**
       * @desc Disable triggering ready message on load on hybrid
       * @type {Boolean}
       */
      disableReadyOnLoad: {
        type: Boolean,
        value: false
      }
    };
  }

  /**
   * ready is a Polymer lifecycle event
   * @see https://www.polymer-project.org/2.0/docs/devguide/custom-elements#element-lifecycle
   */
  ready() {
    super.ready();

    let device = window.disney && window.disney.device;

    if (device) {
      this.isEmbedded = device.embedded;
      this.isIOS = device.platform.ios;
      this.isAndroid = device.platform.android;
      this.isFlutter = device.platform.flutter;
      if (this.isEmbedded) {

        // only create native bridge if embedded
        this._nativeBridge = window.disney.nativeBridgeFactory.createNativeBridge();

        // trigger ready message on hybrid
        if (!this.disableReadyOnLoad) {
          this._nativeBridge.sendReadyMessage();
        }
      }
    }
  }

  /**
   * @desc Register a method for native app to call
   *   - Method is registered as COMWebComponentsNBPlugin.{callBackName} by default
   *
   * @param {String} callBackName - callBack function name to register with
   * @param {Object} callBack - callBack function
   */
  registerNativeCallBack(callBackName, callBack) {
    window.disney[this.nativeBridgePluginName] = window.disney[this.nativeBridgePluginName] || {};

    window.disney[this.nativeBridgePluginName][callBackName] = callBack;
  }

  /**
   * @desc Trigger a custom method on native app
   *   -- Will call a method defined under COMWebComponentsNBPlugin Plugin in native app by default
   *
   * @param {String} methodName - method name on native app plugin
   * @param {Object} params - A JSON object of keys and values
   */
  triggerNativeFunction(methodName, params) {
    window.disney.nativeBridgeFactory.createNativeBridge().sendCustomMessage(
      this.nativeBridgePluginName + '.' + methodName,
      params
    );
  }
}
window.customElements.define(COMNativeBridge.is, COMNativeBridge);
